<template>
    <div class="fzxw">
        <div class="banner">
            <img class=" banner_img" src="../../static/img/news_banner.png" alt="">
        </div>
        <div class="content">
            <div class="qb w1200">
                <div class="hx" v-for="(item,i) in newContent" :key="i" v-if="$route.query.id - 0 === i">
                    <h4>{{item.newtitle}}</h4>
                    <p>
                        <span>作者：北京飞猪科技有限公司</span>
                        <span>时间：{{item.date}}</span>
                    </p>
                    <p class="sj_text">{{item.nr}}</p>
                    <p class="yj" v-if="$route.query.id === '2'">
                        <img :src="item.ximg" alt="">
                    </p>
                    <p class="yj" v-if="$route.query.id === '0'">
                        <img :src="item.ximg" alt="">
                    </p>
                    <p class="sj_text">{{item.nr1}}</p>
                    <p class="yj" v-if="$route.query.id === '6'">
                        <img :src="item.ximg" alt="">
                    </p>
                    <p class="yj" v-if="$route.query.id === '1'">
                        <img :src="item.ximg" alt="">
                    </p>
                    <p class="sj_text">{{item.nr2}}</p>
                    <p class="yj" v-if="$route.query.id === '4'">
                        <img :src="item.ximg" alt="">
                    </p>
                    <p class="yj" v-if="$route.query.id === '5'">
                        <img :src="item.ximg" alt="">
                    </p>
                    <p class="yj" v-if="$route.query.id === '3'">
                        <img :src="item.ximg" alt="">
                    </p>
                    <p class="sj_text">{{item.nr3}}</p>
                    <p class="sj_text">{{item.nr4}}</p>
                    <p class="sj_text">{{item.nr5}}</p>
                    <p class="sj_text">{{item.nr6}}</p>
                    <p class="sj_text">{{item.nr7}}</p>
                    <p class="sj_text">{{item.nr8}}</p>
                    <p class="sj_text">{{item.nr9}}</p>
                    <p class="fh" @click="$router.push({path: '/qywh', query: {page: 4} })">
                        <img src="../../static/img/news_fanhui.png" alt="">
                    </p>
                </div>
                <!-- 上下篇 -->
                <div class="hy w1200" v-if="$route.query.id === '1'">
                    <div class="hx_1 w1200">
                        <span>上一篇</span>
                        <span>下一篇</span>
                    </div>
                    <ul class="news_text" v-for="(item,b) in newa" :key="b">
                        <li>
                            <div class="left">
                                <span>{{item.day}}</span>
                                <span class="hx1"></span>
                                <span>{{item.month}}</span>
                                <span>{{item.year}}</span>
                            </div>
                            <div class="right">
                                <h4>{{item.xwnr}}</h4>
                            </div>
                            <div class="ckgd" @click="$router.push({path:item.path })">
                                <p>
                                    <span>查看更多</span>
                                    <span><img src="../../static/img/baijt.png" alt=""></span>
                                </p>
                            </div>
                        </li>

                    </ul>
                </div>
                <div class="hy w1200" v-if="$route.query.id === '2'">
                    <div class="hx_1 w1200">
                        <span>上一篇</span>
                        <span>下一篇</span>
                    </div>
                    <ul class="news_text" v-for="(item,b) in new1" :key="b">
                        <li>
                            <div class="left">
                                <span>{{item.day}}</span>
                                <span class="hx1"></span>
                                <span>{{item.month}}</span>
                                <span>{{item.year}}</span>
                            </div>
                            <div class="right">
                                <h4>{{item.xwnr}}</h4>
                            </div>
                            <div class="ckgd" @click="$router.push({path:item.path })">
                                <p>
                                    <span>查看更多</span>
                                    <span><img src="../../static/img/baijt.png" alt=""></span>
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="hy w1200" v-if="$route.query.id === '3'">
                    <div class="hx_1 w1200">
                        <span>上一篇</span>
                        <span>下一篇</span>
                    </div>
                    <ul class="news_text" v-for="(item,b) in new2" :key="b">
                        <li>
                            <div class="left">
                                <span>{{item.day}}</span>
                                <span class="hx1"></span>
                                <span>{{item.month}}</span>
                                <span>{{item.year}}</span>
                            </div>
                            <div class="right">
                                <h4>{{item.xwnr}}</h4>
                            </div>
                            <div class="ckgd" @click="$router.push({path:item.path })">
                                <p>
                                    <span>查看更多</span>
                                    <span><img src="../../static/img/baijt.png" alt=""></span>
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="hy w1200" v-if="$route.query.id === '4'">
                    <div class="hx_1 w1200">
                        <span>上一篇</span>
                        <span>下一篇</span>
                    </div>
                    <ul class="news_text" v-for="(item,b) in new3" :key="b">
                        <li>
                            <div class="left">
                                <span>{{item.day}}</span>
                                <span class="hx1"></span>
                                <span>{{item.month}}</span>
                                <span>{{item.year}}</span>
                            </div>
                            <div class="right">
                                <h4>{{item.xwnr}}</h4>
                            </div>
                            <div class="ckgd" @click="$router.push({path:item.path })">
                                <p>
                                    <span>查看更多</span>
                                    <span><img src="../../static/img/baijt.png" alt=""></span>
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="hy w1200" v-if="$route.query.id === '5'">
                    <div class="hx_1 w1200">
                        <span>上一篇</span>
                        <span>下一篇</span>
                    </div>
                    <ul class="news_text" v-for="(item,b) in new4" :key="b">
                        <li>
                            <div class="left">
                                <span>{{item.day}}</span>
                                <span class="hx1"></span>
                                <span>{{item.month}}</span>
                                <span>{{item.year}}</span>
                            </div>
                            <div class="right">
                                <h4>{{item.xwnr}}</h4>
                            </div>
                            <div class="ckgd" @click="$router.push({path:item.path })">
                                <p>
                                    <span>查看更多</span>
                                    <span><img src="../../static/img/baijt.png" alt=""></span>
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="hy w1200" v-if="$route.query.id === '6'">
                    <div class="hx_1 w1200">
                        <span>上一篇</span>
                    </div>
                    <ul class="news_text" v-for="(item,b) in new5" :key="b">
                        <li>
                            <div class="left">
                                <span>{{item.day}}</span>
                                <span class="hx1"></span>
                                <span>{{item.month}}</span>
                                <span>{{item.year}}</span>
                            </div>
                            <div class="right">
                                <h4>{{item.xwnr}}</h4>
                            </div>
                            <div class="ckgd" @click="$router.push({path:item.path })">
                                <p>
                                    <span>查看更多</span>
                                    <span><img src="../../static/img/baijt.png" alt=""></span>
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
                 <div class="hy w1200" v-if="$route.query.id === '0'">
                    <div class="hx_1 w1200">
                        <span>下一篇</span>
                    </div>
                    <ul class="news_text" v-for="(item,b) in new6" :key="b">
                        <li>
                            <div class="left">
                                <span>{{item.day}}</span>
                                <span class="hx1"></span>
                                <span>{{item.month}}</span>
                                <span>{{item.year}}</span>
                            </div>
                            <div class="right">
                                <h4>{{item.xwnr}}</h4>
                            </div>
                            <div class="ckgd" @click="$router.push({path:item.path })">
                                <p>
                                    <span>查看更多</span>
                                    <span><img src="../../static/img/baijt.png" alt=""></span>
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'fzxw',
  data () {
    return {
          idNum: '',
      newa: [
        {
          day: '18',
          month: '12',
          year: '2018',
          xwnr: '热烈庆祝北京飞猪科技获得了“中关村高新技术企业”证书',
          path: '/fzxw?page=4&id=0'
        },
        {
          day: '14',
          month: '08',
          year: '2018',
          xwnr: '北京飞猪科技在上海分公司召开第二季度会议',
          path: '/fzxw?page=4&id=2'
        }
      ],
      new1: [
        {
          day: '08',
          month: '11',
          year: '2018',
          xwnr: '北京飞猪科技董事长出席金融峰会并在当地调研',
          path: '/fzxw?page=4&id=1'
        },
        {
          day: '16',
          month: '07',
          year: '2018',
          xwnr: '发展与改革势在必行！',
          path: '/fzxw?page=4&id=3'
        }
      ],
      new2: [
        {
          day: '14',
          month: '08',
          year: '2018',
          xwnr: '北京飞猪科技在上海分公司召开第二季度会议',
          path: '/fzxw?page=4&id=2'
        },
        {
          day: '28',
          month: '06',
          year: '2018',
          xwnr: '北京飞猪科技车险保费跨越率在不断增涨，正在奋进行业前列',
          path: '/fzxw?page=4&id=4'
        }
      ],
      new3: [
        {
          day: '16',
          month: '07',
          year: '2018',
          xwnr: '发展与改革势在必行！',
          path: '/fzxw?page=4&id=3'
        },
        {
          day: '11',
          month: '06',
          year: '2018',
          xwnr: '离不开交流的技术与运营',
          path: '/fzxw?page=4&id=5'
        }
      ],
      new4: [
        {
          day: '28',
          month: '06',
          year: '2018',
          xwnr: '北京飞猪科技车险保费跨越率在不断增涨，正在奋进行业前列',
          path: '/fzxw?page=4&id=4'
        },
        {
          day: '20',
          month: '05',
          year: '2018',
          xwnr: '北京飞猪科技技术部门召开关于太平专属APP的会议',
          path: '/fzxw?page=4&id=6'
        }
      ],
      new5: [
        {
          day: '11',
          month: '06',
          year: '2018',
          xwnr: '离不开交流的技术与运营',
          path: '/fzxw?page=4&id=5'
        }
      ],
      new6: [
        {
          day: '08',
          month: '11',
          year: '2018',
          xwnr: '北京飞猪科技董事长出席金融峰会并在当地调研',
          path: '/fzxw?page=4&id=1'
        }
      ],
      newContent: [
           {
          id: '0',
          newtitle: '热烈庆祝北京飞猪科技获得了“中关村高新技术企业”证书',
          date: '2018-12-18',
          nr: '近期，北京飞猪科技经过公司所有员工的共同努力，公司的规模和业务都得到了飞速的发展与提升，最令员工们激动与欣喜的事情——北京飞猪科技获得了“中关村高新技术企业”证书。',
          nr1: '飞猪科技成立至今三年，期间，公司所有员工不敢有一丝懈怠，为公司今后不断壮大而为之奋斗。在公司项目部各位同事日以继夜的努力下，公司收获了越来越多的软件著作权证书，这为公司的知识产权储备打下了坚实的基础。',
          nr2: '同时，公司各部门通力合作，在为公司进行各种资质证书的申报工作，他们认真研究并熟悉了申报前或认定后日常管理的重点工作有哪些，通过熟之后，北京飞猪科技严格加强研发项目组织、加强做好知识产权申报管理、不断健全研发组织管理体系、做好科技成果转化、规范研发投入和高新技术企产品（服务）收入的核算。',
          nr3: '最终，通过北京飞猪科技各位员工的不懈努力，北京飞猪科技正式在2018年12月13日获得中关村高新技术企业”证书，并相信通过大家的努力，提升公司的市场竞争力，树立良好的企业形象，做好行业内示范带头作用，促进企业不断向前进步，未来，公司的发展势不可挡。',
          ximg: require('../../static/img/gxqy.png')

        },
        {
          id: '1',
          newtitle: '北京飞猪科技董事长出席金融峰会并在当地调研',
          date: '2018-11-08',
          nr: '2018年11月6日-7日，集团公司董事长一行出席战略性互联互通示范项目金融峰会并在当地调研，期间分别拜会了市委书记和政府市长。集团公司副总裁、业务管理部和投资管理部主要负责人同志陪同。',
          nr1: '11月6日下午，董事长应邀参加书记、市长主持的战略性互联互通示范项目金融峰会重要嘉宾集体会见活动。董事长对市委、市政府给予业务发展的支持表示感谢，并表示将发挥自身优势，积极参与经济社会建设，助力发展。',
          nr2: '董事长一行在分公司进行调研，听取机构工作情况汇报，并就当前市场形势以及明年工作思路进行座谈。对产、寿分公司践行新发展理念，对所取得的成绩给予充分肯定。并指出，既要做好今年的收尾工作，又要系统谋划明年工作，争取实现开门红：一要始终坚定不移践行向高质量发展转型，坚持发展是第一要务，制定稳中求进的发展思路和目标。二要持续推进深化改革，要在对标市场、对标先进中强化激励约束，充分调动广大干部员工的积极性、主动性和创造性。三要服务经济社会发展大局，在服务乡村振兴、脱贫攻坚、健康中国、社会治理等领域持续发挥保险业主力军作用。四要落实一体化战略，要树立一盘棋的发展理念，既要相互协助，又要设计好利益机制。五要抓好队伍建设，对管理队伍要优化年龄结构，优化专业结构，对销售队伍要做大做强做优。六要更加有效地防范风险，将防范风险放在突出位置，守住不发生系统性风险的底线，推动公司健康可持续发展。',
          nr3: '期间，董事长还会见了区委书记以及政府相关领导',
          ximg: require('../../static/img/xw_1.png')

        },
        {
          id: '2',
          newtitle: '北京飞猪科技在上海分公司召开第二季度会议',
          date: '2018-08-14',
          nr: '8月14日，以“新起点、新高度，中国服务业回望与前瞻”为主题的第二季度中国服务资源服务战略发展大会在上海隆重举办。来自各省重要部门，各服务部门和各地方的分支服务机构的领导和股东参加了大会。其中，北京外企人力资源服务有限公司股东受邀出席活动并发表演讲。',
          nr1: '在大会上，北京外企股东主要以“新时代新思想新征程——打造人力资本服务发展新动能”为主题进行分享。首先从抢人大战、共享经济、两税合并、便民服务等现象，分析这些市场和政策性变化给企业生存的基础和工作模式带来的影响。',
          nr2: '公司发展的服务本质上是引致性服务，根源于实体产业发展带来的需求，带有一定从属性的性质。公司发展的服务的转型最终还是要依托实体产业的变化而变化。',
          nr3: '所谓的服务转型，就是从过去单纯的、以交付性为主的事务性服务，提升到现有的资源性服务，也就是强调服务的产品化问题，强调服务产品的效率、供给问题等等。最终，要上升到价值型服务，上升到赋能客户，强调组织服务的阶段。',
          nr4: '公司发展的服务的下一阶段，价值型服务阶段，就是指，公司发展中的服务，企业将面临新挑战，也就是由过去重视关系、重视产品，向顾问式、价值型服务转型，关注的重点是市场需求的问题，研究的是如何赋能客户的问题，更加强调服务的专业性要求，比拼的是如何能够更加深度介入到企业的组织当中去，嵌入到组织的业务发展流程当中去，从观察客户的角色，转换为与客户一同创造价值的伙伴角色。',
          nr5: '北京外企股东的一席话，带领着北京飞猪科技所有的领导与股东对未来关于客户的需求与服务展开了一个又一个的想法，在未来的发展中，会更加注重这些所谈及到的想法并努力去实现这些，让未来不再是未来，让公司更加稳定发展。',
          ximg: require('../../static/img/news_man.png')
        },
        {
          id: '3',
          newtitle: '发展与改革势在必行！',
          date: '2018-07-16',
          nr: '经过一年的不断努力，各个部门业绩快速增长，比去年同期增长3倍以上，平均到每个人，也有超过1倍的增长，横向比较的话，我们一个人的业绩，超过多数同业公司一个TEAM的业绩。',
          nr1: '这其中的努力脱不出整个团队的完美合作，从技术的开发、运营的推广到业绩人员不断的与合作公司交谈，这些都是每个人的劳动成果，在公司今后的发展历史上也是不可泯灭的。',
          nr2: '公司的发展正在一步一步向着世界级发展，其中离不开公司各大股东的支持，不断完善公司信息，提高公司的完整度，合格程度，更是不断地壮大团队，发展成将近一条龙服务与发展的企业。',
          nr3: '技术部门在具体的工作上面大力协作，每个大项目的执行，从项目可行性论证、报价、方案策划、谈判接洽、UI设计、前端开发、程序开发、售后服务整个过程，技术部门都是深度参与，提供给力的支持。技术的支持才是最重要的支持，抓住相关的产品重点，从源头上去解决问题，大大缩短时间，提高工作效率。',
          nr4: '随着公司这一年的大力发展，效益越来越高，合作公司越来越多，公司的发展平台也是越来越大，这是公司的发展前景，不断进步，前进的时代，同时，公司更应该关注往后发展的道路，从哪些平台，哪些机构，哪些产品上找到更加能够对公司发展锦上添花的发展机会，让公司发展更加快速与稳定！',
          ximg: require('../../static/img/fztp.png')
        },
        {
          id: '4',
          newtitle: '北京飞猪科技车险保费跨越率在不断增涨，正在奋进行业前列',
          date: '2018-06-28',
          ximg: require('../../static/img/xw_2.png'),
          nr: '2018年6月28日，北京飞猪科技车险保费跨越率不断增长，继2016年保费增涨、2017年保费增涨以后，再次实现了飞猪保险科技车险保费的历史性跨越，成为公司发展历程上重要的一笔历史记录。',
          nr1: '保费突破率不断增涨并且正在奋进行业前列，这是公司发展史上新的里程碑，标志着公司已经跨入了新的发展时期。近年来，公司认真贯彻北京飞猪科技集团党委决策部署，突出加强党的建设，全面深化市场对标，以“七抓七促”为总揽，坚持“发展是第一要务，盈利是生命线，合规经营是底线”，不断优化经营布局，构筑车险发展新优势，培育商业非车发展新动力，开创政策性业务新空间，激发基层发展新活力。',
          nr2: '在移动互联、云计算、大数据等新技术的推动下，科学创新已经成为北京飞猪科技不断进步发展的引擎。飞猪科技始终保持与市场相适应的发展速度，通过加快产品、销售服务模式、技术应用、经营模式等方面的创新，以“保险+”的方式构建车主生态圈、健康生态圈和汽车零配件电商平台四大生态圈，进一步提升产品创新和市场开拓能力。在产品、服务和技术等方面，正引领着行业的创新和发展。',
          nr3: '如今的飞猪科技，已经站在了增长率不断提高的历史新起点上，飞猪科技将继续坚持“人民保险，服务人民”的历史使命，以保险供给升级服务经济社会发展大局、促进发展方式转变，以改革创新推进管理模式、经营模式和商业模式升级，全面提升公司的经营能力和管理能力，努力谱写“中国梦”篇章！'
        },
        {
          id: '5',
          newtitle: '离不开交流的技术与运营',
          date: '2018-6-11',
          nr: '在发展越来越快速的科技时代，技术可能就会不停的被人们提起来，大家都会认为技术已经是我们生活中不能离开的东西，它无时无刻不在影响着人们的生活，我们所看到的，听到的，感受的一切仿佛都和它息息相关，但是，往往人们会忘记一个更重要也可以说是和技术不可或缺的一个，那就是——运营。',
          nr1: '运营是什么？',
          nr2: '运营就是对运营过程的计划、组织、实施和控制，是与产品生产和服务创造密切相关的各项管理工作的总称。从另一个角度来讲，运营管理也可以指为对生产和提供公司主要的产品和服务的系统进行设计、运行、评价和改进的管理工作。',
          nr3: '运营的分类有哪些？',
          nr4: '运营分为市场运营，用户运营，内容运营，社区运营以及商务运营几个大类。',
          nr5: '市场运营:以Marketing为手段，通过花钱的不花钱的方式，进行对产品的一系列宣传，曝光，营销等行为的干预手段。',
          nr6: '用户运营:以人为中心的运营手段，常见于UGC社区，以贴近用户，团结用户，引导用户为手段的运营方式。',
          nr7: '社区运营指的是面向社区消费者进行的干预活动。',
          nr8: '商务运营:这类方式多见于一些商务B2B的产品，分为BD和销售两种。',
          nr9: '运营分类多样，更是体现出它的不同，因此，运营的效果与技术还是不分上下的，大家的侧重点不同，但都是为了公司能够更好地发展。',
          ximg: require('../../static/img/jsyyy_talk.png')
        },
        {
          id: '6',
          newtitle: '北京飞猪科技技术部门召开关于太平专属APP的会议',
          date: '2018-5-20',
          nr1: '2018年5月20日，北京飞猪科技有限公司在上海分公司召集所有技术部门，针对太平公司想要专属车险APP做出了详细的讨论。其中，部门负责人重点强调了太平公司人员的想法，对此做出了几点总结。',
          nr2: '1、要注重专属APP的重要性',
          nr3: '技术的门槛可以说是非常的低，有很多仿站或者模板建站的方式存在。这就造成了建设质量的参差不齐，甚至有些公司完全不懂，利用几个模版也在这个行业浑水摸鱼，价格从几百到几万元不等，水平也是各不一样。有些小公司对自己公司的要求不高，只对价格有要求，价格越低越好，也不考察网建公司的技术实力，往往捡小便宜最后吃大亏。',
          nr4: '2、要知道建立也要懂得维护',
          nr5: '有些企业认为建设完成就什么问题都没有，然后就等着订单。不做好基础设置，搜索引擎怎么收录？不收录如何看到你的东西？建立的代码是否符合规范？一个APP制作完成后还有很多事要做，推广、SEO优化、运营等。',
          nr6: '3、还是要做最大的收益',
          nr7: '一些企业建设了网站但是一直没有效果，也就是说他没有从这个东西中得到任何的收益，就认为没什么作用。建设要想提高企业的产品销售额，就需要长期坚持进行网站运营，任何一个网站实现盈利都不是一朝一夕的事情，都需要花心思去研究。',
          nr8: '会议结束，技术部门各个认真记录负责人的重点，争取把事情做到最优化、效益最好。',
          ximg: require('../../static/img/thb_talk.png')
        },
       
      ]

    }
  },
  mounted() {
  let id = this.$route.query.id
   if(this.isMobile()) {
        this.$router.push({path:'/newDetails?id=', query: {id:id}})
        } else {
         this.$router.push({path:'/fzxw?page=4&id=', query: {id: id}})
        }
  },
  methods: {
       isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
    }
  },
}
</script>

<style lang="scss" scoped>
.content {
    max-width: 19.2rem;
    width: 100%;
    margin: 0 auto;
    font-size: .24rem;
    min-height: 16rem;
    position: relative;
    background-color: #f2f2f2;
    .qb {
        left: 50%;
        margin: 0 auto;
        background-color: #f2f2f2;
        position: absolute;
        transform: translateX(-50%) translateY(-250px);
        .hx {
            box-sizing: border-box;
            // width: 11.2rem;
            width: 12rem;
            margin: 0 auto;
            background-color: #fff;
            padding: .3rem .4rem;
            h4 {
                font-size: .36rem;
                line-height: .75rem;
            }
            p {
                color: #676767;
                line-height: .38rem;
                padding: 5px 0;
                span {
                    color: #979797;
                    font-size: .2rem;
                }
            }
            .yj {
                text-align: center;
                line-height: 35px;
                img {
                    margin: 0 auto;
                    width: 5.50rem;
                    height: 3.45rem;
                    padding: .15rem;
                }
            }
            .fh {
                width: 2rem;
                height: 1rem;
                margin: .1rem 0 .2rem 0;
                cursor: pointer;
            }
        }
        .hy {
            .hx_1 {
                height: 1.2rem;
                line-height: 1.2rem;
                font-size: .38rem;
                margin: .5rem 0 .2rem 0;
                span {
                    width: 50%;
                    display: block;
                    float: left;
                }
            }
            .news_text {
                 text-align: center;
                li {
                    box-sizing: border-box;
                    width: 48%;
                    background-color: #fff;
                    height: 1.75rem;
                    float: left;
                    margin-top: .2rem;
                    padding-top: .15rem;
                    color: #949494;
                    .left {
                        width: 1.05rem;
                        height: 1.5rem;
                        float: left;
                        margin-left: .25rem;
                        text-align: center;
                        border-right: 2px solid #cbcbcb;
                        span {
                            float: left;
                            font-size: .22rem;
                            line-height: .4rem;
                            width: 1.05rem;
                        }
                        .hx1 {
                            margin-left: .3rem;
                            width: .35rem;
                            height: .1rem;
                            line-height: .1rem;
                            border-bottom: 2px solid #cbcbcb;
                        }
                        span:nth-child(1) {
                            font-size: .32rem;
                        }
                    }
                    .right {
                        width: 3.95rem;
                        float: left;
                        line-height: .4rem;
                        font-size: .3rem;
                        padding-left: .2rem;
                        text-align: left;
                        padding-top: .2rem;
                    }
                    .ckgd {
                        width: 5.76rem;
                        // width: 190px;
                        height: 1.80rem;
                        background-color: #de101d;
                        margin-top: -.2rem;
                        position: absolute;
                        font-size: .2rem;
                        color: #f0fff8;
                        opacity: 0;
                        p {
                            height: .2rem;
                            display: flex;
                            padding-top: .8rem;
                            justify-content: space-between;
                            span {
                                padding: 0 .4rem;
                            }
                        }
                    }
                }
                li:hover {
                    background-color: #de101d;
                    .ckgd {
                        opacity: 1;
                    }
                }
                li:nth-child(odd) {
                    margin-right: .23rem;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Fzxw.vue